import { useQueryParam } from '@Alias/hooks';

export default function useRedirectURLParam() {
  const redirectURI = useQueryParam('redirect_uri');
  return redirectURI && decodeURIComponent(redirectURI);
}
